import {Module} from "wrapper6";
import Glide from '@glidejs/glide';

var $ = jQuery;

export default class RelatedSlider extends Module {

    ready(app) {

        const SLIDER_CONTAINERS = document.querySelectorAll('.related-slider');

        if (SLIDER_CONTAINERS.length > 0) {

            for (let i = 0; i < SLIDER_CONTAINERS.length; i++) {

                const SLIDER_CONTAINER = SLIDER_CONTAINERS[i];
                const GLIDE = SLIDER_CONTAINER.querySelector('.glide');

                if (GLIDE) {

                    // setup slider
                    let glider = new Glide(GLIDE, {
                        type: 'slider', // has to be slider
                        startAt: 0,
                        perView: 4,
                        gap: 15,
                        animationDuration: 800,
                        peek: {
                            after: 0,
                            before: 0
                        },
                        breakpoints: {
                            1350: {
                                perView: 3,
                                peek: {
                                    after: 0,
                                    before: 0
                                },
                            },
                            960: {
                                perView: 2,
                                peek: {
                                    after: 0,
                                    before: 0
                                },
                            },
                            650: {
                                perView: 1,
                                peek: {
                                    after: 80,
                                    before: 0
                                }
                            },
                            450: {
                                perView: 1,
                                peek: {
                                    after: 40,
                                    before: 0
                                }
                            },
                            350: {
                                perView: 1,
                                peek: {
                                    after: 0,
                                    before: 0
                                }
                            }
                        },
                        rewind: false
                    });

                    glider.mount();
                }
            }
        }
    }
}